export default __webpack_public_path__ + "static/media/warning--junction-with-merge-from-left--g1.bf9a8c4e.png";